
<div class="cadre-annonce" :class="jel_getClassObject(content)">
  <div class="annonce loterie-container w-100">
    <div class="logo-loterie">
      <b-link v-bind="jel_getLienBinding(content.lien)">
        <b-img-lazy :src="jel_getFichierSrc(content.image)" alt="" class="pr-1" />
      </b-link>

      <div v-if="isProgressifActif" class="date-tirage">
        <b-img-lazy
          v-if="isSuperTirage"
          :src="jel_getFichierSrc(content.formatJeu.image2)"
          alt="Super Tirage"
          class="super-tirage"
        />
        <div class="jour">{{ jour }}</div>
        <div class="date">{{ date }}</div>
      </div>
    </div>
    <div v-if="isProgressifActif" class="gros-lot">
      <div class="groslot-info">
        <template v-if="content.formatJeu.field === 'lotto649'">
          <div class="lotto649">
            <div class="groslot-avenir"></div>
            <div class="classique649">
              <span class="texte">{{ $i18n.tc('messageComponent.leClassique') }}</span>
              <span class="valeur">
                {{
                  getMillions(loterie.ProchainGrosLotTirageClassique.value) +
                  ' ' +
                  $i18n.tc('messageComponent.million')
                }}
              </span>
              <!-- <sup>*</sup> -->
            </div>
            <div class="boule-or649 groslot-boule-or">
              <div>
                <b-img-lazy
                  :src="jel_getFichierSrc(content.formatJeu.image)"
                  alt="Boule d'or 6/49"
                  class="pr-1"
                />
              </div>
              <div>
                <span class="texte">{{ $i18n.tc('messageComponent.bouleDOr') }}</span
                ><br />
                <span class="valeur groslot-valeur">
                  {{
                    getMillions(loterie.ProchainGrosLotBouleOr.value) +
                    ' ' +
                    $i18n.tc('messageComponent.million')
                  }}<sup>*</sup>
                </span>
              </div>
            </div>
          </div>
        </template>
        <template v-if="content.formatJeu.field === 'lottoMax'">
          <div class="lottoMax">
            <div class="groslot-avenir"></div>
            <div class="lotto-max-classique">
              {{
                getMillions(loterie.ProchainGrosLot.value) +
                ' ' +
                $i18n.tc('messageComponent.million')
              }}<sup>*</sup>
            </div>
            <div class="lotto-max-plus">
              <b-img-lazy :src="jel_getFichierSrc(content.formatJeu.image)" alt="" />
              <span>
                {{
                  loterie.NbProchainLotSupplementaire.value +
                  ' ' +
                  $i18n.tc('messageComponent.lots1Million')
                }}
              </span>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div v-else>
      <div class="error-gros-lot text-left text-md-center">
        {{ $i18n.tc('messageComponent.error') }}
      </div>
    </div>
    <div v-if="isProgressifActif" class="mention-speciale">{{ texteMentionSpeciale }}</div>
    <div class="boutons">
      <b-link v-bind="jel_getLienBinding(content.lien)" class="acheter"
        >{{ $i18n.tc('messageComponent.acheter') }}
      </b-link>
      <b-link v-bind="jel_getLienBinding(content.lien)" class="resultats"
        >{{ $i18n.tc('messageComponent.resultats') }}
      </b-link>
    </div>
  </div>
</div>
